import React from 'react';
import { Link } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';
import { SEO } from '../components/SEO';

export const NotFoundPage = () => (
  <main className="min-h-[70vh] flex items-center justify-center bg-gray-50 px-4 py-20" data-testid="not-found-page">
    <SEO
      title="Səhifə tapılmadı | İDK BOKT"
      description="Axtardığınız səhifə mövcud deyil və ya köçürülüb. Ana səhifəyə qayıdaraq davam edin."
      path="/404"
      noindex
    />
    <div className="max-w-xl w-full text-center">
      <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-blue-50 mb-6">
        <span className="text-4xl font-bold text-blue-600" data-testid="not-found-code">404</span>
      </div>
      <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-3">
        Səhifə tapılmadı
      </h1>
      <p className="text-gray-600 mb-8">
        Axtardığınız səhifə mövcud deyil və ya köçürülüb. Ana səhifəyə qayıdaraq davam edə bilərsiniz.
      </p>
      <div className="flex flex-col sm:flex-row gap-3 justify-center">
        <Button asChild size="lg" className="bg-blue-600 hover:bg-blue-700" data-testid="not-found-home-btn">
          <Link to="/">
            <Home className="mr-2 h-4 w-4" />
            Ana səhifə
          </Link>
        </Button>
        <Button asChild variant="outline" size="lg" data-testid="not-found-contact-btn">
          <Link to="/elaqe">
            <ArrowLeft className="mr-2 h-4 w-4" />
            Bizimlə əlaqə
          </Link>
        </Button>
      </div>
    </div>
  </main>
);
